import { useQuery } from "@tanstack/react-query";

import { api } from "@utils/api";

import { useQueryErrorHandling } from "@hooks/useQueryErrorHandling";

import { DashboardQueryProps } from "@customTypes/dashboard";

import { dashboardQKeys } from "./queryKeys";


const select = (
  res: any
):
  | {
      date: string;
      ordered: number;
      completed: number;
    }[]
  | null => {
  //   console.log(res.data);
  const newData = [];

  if (Object.keys(res.data).length) {
    for (const i in res.data.data) {
      const { date, ordered, completed } = res.data.data[i];
      newData.push({
        date,
        ordered,
        completed,
      });
    }

    return newData;
  }

  return null;
};

export const useGetLabsTrend = ({
  dateRange,
  startDate,
  endDate,
  userId,
}: DashboardQueryProps) => {
  const handleErrors = useQueryErrorHandling();

  return useQuery({
    queryKey: dashboardQKeys.labsTrendWithFilters({
      dateRange,
      startDate,
      endDate,
      userId,
    }),
    queryFn: () => {
      return api.get("analytics/labs/daily-trends", {
        params: {
          range: dateRange?.replaceAll("-", "_"),
          ...(dateRange === "custom" && {
            start_date: startDate,
            end_date: endDate,
          }),
          ...(userId && {
            staff_id: userId,
          }),
        },
      });
    },
    select,
    staleTime: 1000 * 60 * 5, // 5 minutes
    enabled:
      dateRange !== "custom" ||
      !!(dateRange === "custom" && startDate && endDate),

    onError: (res: any) => {
      console.error("[From Get Labs trend]", res);
      handleErrors(res, "query");
    },
  });
};
